import { getEnv } from "@/utils/runtime-config";

/**
 * Extracts hostname from a URL string
 * e.g., "https://dev-core-sdt-z11.elaniin.dev" -> "dev-core-sdt-z11.elaniin.dev"
 */
const extractHostname = (url: string | undefined): string => {
  if (!url) return "";
  try {
    return new URL(url).hostname;
  } catch {
    // If URL parsing fails, try to remove protocol manually
    return url.replace(/^https?:\/\//, "");
  }
};

export const REVERB_CONFIG = {
  appKey: getEnv("VITE_REVERB_APP_KEY"),
  backendUrl: getEnv("VITE_BACKEND_URL"),
  scheme: getEnv("VITE_REVERB_SCHEME"),
  get host() {
    return getEnv("VITE_REVERB_HOST") || extractHostname(this.backendUrl);
  },
  get port() {
    return getEnv("VITE_REVERB_PORT");
  },
  get authEndpoint() {
    return `${this.backendUrl}/broadcasting/auth`;
  },
} as const;

export const getWebSocketUrl = () => {
  const portSuffix = REVERB_CONFIG.port ? `:${REVERB_CONFIG.port}` : "";
  return `${REVERB_CONFIG.scheme}://${REVERB_CONFIG.host}${portSuffix}/app/${REVERB_CONFIG.appKey}`;
};
